module.exports = __webpack_public_path__ + "img/t1.c1b3056a.png";